import { createFileRoute } from '@tanstack/react-router';

/**
 * OSHA Details 2 Route Definition
 * Component is loaded from route.lazy.tsx for automatic code splitting
 *
 * Authentication is handled by the parent _protected layout route.
 */
export const Route = createFileRoute('/_protected/osha-details2/$muns')({
  // No beforeLoad - parent _protected handles auth
});
